module.exports = __webpack_public_path__ + "fonts/poppins-regular.29cc97af.ttf";